module.exports = __webpack_public_path__ + "img/leaf1.2a5da8d8.png";